var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9 80.4a13.4 13.4 0 1 1-13.4-13.4h13.4v13.4zm6.7 0a13.4 13.4 0 0 1 26.8 0v33.5a13.4 13.4 0 1 1-26.8 0V80.4z",
    fill: "#E01E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2 26.9a13.4 13.4 0 1 1 13.4-13.4v13.4H47.2zm0 6.8a13.4 13.4 0 0 1 0 26.8H13.6a13.4 13.4 0 0 1 0-26.8h33.6z",
    fill: "#36C5F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 47.2a13.4 13.4 0 1 1 13.4 13.4h-13.4V47.2zm-6.8 0a13.4 13.4 0 0 1-26.8 0V13.6a13.4 13.4 0 0 1 26.8 0v33.6z",
    fill: "#2EB67D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4 100.8a13.4 13.4 0 1 1-13.4 13.4v-13.4h13.4zm0-6.8a13.4 13.4 0 0 1 0-26.8h33.6a13.4 13.4 0 0 1 0 26.8H80.4z",
    fill: "#ECB22E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackLogo);
export default __webpack_public_path__ + "static/media/slack-logo.6c658e050452144fc10ce97dd863e8c2.svg";
export { ForwardRef as ReactComponent };